<template>
  <div v-if="!edit_modal">
    <h1 class="h3 mb-3 text-gray-800" :class="`${morph ? 'pl-3' : ''} `">
      {{ $t("Cadastrar Atividade") }}
    </h1>

    <b-card :class="`${morph ? '' : 'shadow'} `">
      <template v-slot:default>
        <loading-animation
          :active.sync="loading"
          :is-full-page="false"
          :opacity="1"
          color="#5895FF"
        />
        <div
          class="alert alert-info bg-gradient-info animate__animated animate__fadeIn d-flex justify-content-start"
          v-if="tipo_coletivo && camposScfv != true"
        >
          <div class="mr-3">
            <span style="font-size: 28px">
              <i class="fas fa-info-circle"></i>
            </span>
          </div>

          <div>
            - Quando a Atividade for do Tipo "ATENDIMENTO COLETIVO", AÇÕES COLETIVAS DE
            CARÁTER NÃO CONTINUADO, ATIVIDADES PAIF, ATIVIDADES PAEFI ou ATIVIDADE DE CARÁTER CONTINUADO será necessário que na próxima página (Edição) você
            selecione os
            <b>Usuários que participarão da Atividade.</b>
            <br />

            - Este item também corresponde as
            <b>Atividades de Oficinas</b> referente ao Serviço selecionado.
          </div>
        </div>
        <form @submit.prevent="addItem" ref="addItem">
          <div class="row">
            <!-- Campos Atividades do Scfv -->
            <form-input 
              v-model="item.tema" 
              grid="12" 
              label="Tema" 
              v-if="camposScfv" 
              :required="true"
            />
            <!-- Campos Atividades do Scfv Tema ou Título-->

            <form-select
              grid="6"
              v-model="item.tipo_id"
              label="Tipo"
              :itens="tipos"
              ajuda="'Se você não encontrar o Tipo de Atividade desejado na lista abaixo, adicione um novo na área de Gestão de Parâmetros ou solicite o cadastro a um Administrador'"
              :loading="loadingTipos"
              :disabled="loadingTipos"
              required="true"
              @change="verifyType(), verifyTypeReuniao()"
            />

            <form-select
              v-model="item.tipo_servico_id"
              label="Serviço"
              grid="6"
              :itens="servicos"
              :disabled="disabledServico"
            />

            <form-input
              v-if="!camposScfv"
              v-model="item.titulo"
              grid="12"
              label="Título"
              :required="true"
            />

            <form-calendar v-model="dataAdd" grid="4" label="Data" :required="true" />

            <form-calendar v-model="format_hora" grid="4" label="Hora" mode="time" />

            <form-input
              v-model="item.duracao"
              grid="4"
              label="Duração"
              placeholder="00:00"
              v-mask="'##:##'"
            />

            <form-select
              v-model="item.participantes"
              label="Usuários Inscritos no Grupo"
              :multiple="true"
              :itens="usuariosvinculados"
              v-if="usuariosvinculados"
              required="true"
            />
            <form-select
              v-if="!usuariosvinculados"
              v-model="item.participantes"
              :label="tipo_coletivo ? 'Técnicos Participantes' : labelParticipantes"
              :multiple="true"
              :itens="listtecnicos"
            />

            <div class="col-md-12 mb-2">
              <label for="tags-basic"><b>Outros Participantes</b></label>
              <b-form-tags
                input-id="tags-basic"
                v-model="item.outros_participantes"
                tag-variant="primary"
                size="sm"
                placeholder="Digite o nome completo do participante e pressione Adicionar"
                add-button-text="Adicionar"
              ></b-form-tags>
            </div>

            <form-input
              v-model="item.qtde_sem_printuario"
              grid="2"
              label="Usuários sem prontuário"
              type="number"
              min="0"
              ajuda="'O quantitativo inserido nesse campo é referente ao número de pessoas que participaram da atividade, que não possuem pronturário aberto no sistema. Esse quantitativo não é contabilizado no RMA, tampouco no relatório de atividade (que demanda a vinculação do usuário para contabilização).'"
            />

            <form-input
              v-model="item.local"
              grid="12"
              label="Local da Atividade"
              v-if="showLocal"
            />

            <form-input
              v-model="item.link_sala_reuniao"
              grid="12"
              label="Link da Sala Virtual"
              v-if="showLocal"
            />

            <!-- <form-input
              v-model="item.outros_participantes"
              grid="12"
              label="Outros Participantes de fora da Rede Socioassistencial"
            /> -->

            <!-- Campos Atividades do Scfv -->

            <form-textarea-editor
              v-model="item.objetivo_especifico"
              grid="12"
              label="Objetivo Específico"
              v-if="camposScfv"
            />

            <form-textarea-editor
              v-model="item.dinamica"
              grid="12"
              label="Dinâmica/Sintese Desenvolvimento"
              v-if="camposScfv"
            />

            <form-textarea-editor
              v-model="item.materiais_utilizados"
              grid="12"
              label="Materiais a serem utilizados"
              v-if="camposScfv"
            />

            <!-- Campos Atividades do Scfv ou Conteúdo-->

            <form-textarea-editor
              v-if="!camposScfv"
              v-model="item.conteudo"
              grid="12"
              label="Conteúdo"
            />
          </div>

          <div class="row d-flex justify-content-end mt-3">
            <form-toggle
              grid="9"
              class="d-flex justify-content-end"
              mt="0"
              v-model="item.privado"
              label="Sigilo?"
            />
            <button
              class="btn btn-success btn-submit mr-3"
              data-style="zoom-in"
              type="submit"
            >
              <i class="fas fa-save" />
              {{ $t("Salvar") }}
            </button>
          </div>
        </form>
      </template>
    </b-card>
  </div>
  <EditarModal
      v-else-if="edit_modal"
      :usuariosvinculados="usuariosvinculados"
      morph_type="ScfvGrupo"
      :morph="true"
      :morph-atividade-id="atividade_id"
  />
</template>

<script>
import EditarModal from "./Edit.vue";
export default {
  props: ["familia", "morph", "usuariosvinculados"],
  name: "Add",
  data() {
    return {
      loading: false,
      item: {
        outros_participantes: [],
      },
      tecnicos: [],
      servicos: [],
      tipos: [],
      camposScfv: false,
      showPrivate: false,
      usuarios_scfv: [],
      tipo_coletivo: false,
      labelParticipantes: "Equipe - Participantes",
      loadingTipos: false,
      disabledServico: false,
      dataAdd: moment().format("YYYY/MM/DD"),
      showLocal: false,
      edit_modal: false,
      atividade_id: null,
    };
  },
  components: {
    EditarModal,
  },
  computed: {
    pessoas() {
      const pessoas = this.usuarios_scfv.lista_inscritos;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: elem.nome_completo + " <b>" + elem.idade_extenso + "</b>",
      }));

      return map;
    },
    listtecnicos() {
      const pessoas = this.tecnicos;
      
      const map = pessoas.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + (elem.profissao ?? 'Não informado') + " - " + elem.nome_unidade,
      }));
      return map;
    },
  },
  mounted() {
    this.camposScfvGrupo();
    this.getServicos();
    this.getTecnicos();
    this.getTipos();
  },
  watch: {
    "item.tipo_id": function (val) {
      const dado = val;
      const result = this.tipos.filter(
        (item) =>
          (item.id == dado && item.value == "ATENDIMENTO COLETIVO") ||
          (item.id == dado && item.value == "AÇÕES COLETIVAS DE CARÁTER NÃO CONTINUADO") ||
          (item.id == dado && item.value == "ATIVIDADES PAIF") ||
          (item.id == dado && item.value == "ATIVIDADES PAEFI") ||
          (item.id == dado && item.value == "ATIVIDADE DE CARÁTER CONTINUADO")
      );

      return result.length > 0
        ? (this.tipo_coletivo = true)
        : (this.tipo_coletivo = false);
    },
  },
  methods: {
    verifyType() {
      this.showPrivate = false;
      this.item.privado = 0;
      this.tipos.filter((e) => {
        if (e.id == this.item.tipo_id && e.value == "DISCUSSÃO DE CASO") {
          this.showPrivate = true;
        }
      });
    },
    verifyTypeReuniao() {
      this.showLocal = false;
      this.tipos.filter((e) => {
        if (e.id == this.item.tipo_id && e.value == "REUNIÃO") {
          this.showLocal = true;
        }
      });
    },
    camposScfvGrupo() {
      if (this.morph && this.morph.type == "ScfvGrupo") {
        this.camposScfv = true;
      } else {
        this.camposScfv = false;
      }
    },
    getTecnicos() {
      axios.get(`api/dashboard/atividades/tecnicos/get`).then((response) => {
        this.tecnicos = response.data;
      });
    },
    getTipos() {
      this.loadingTipos = true;
      axios
        .get(`api/dashboard/atividades/tipos`)
        .then((response) => {
          if (this.morph && this.morph.type == "ScfvGrupo") {
            this.tipos = response.data.filter((item) => {
              return (
                item.value != "DISCUSÃO DE CASO" &&
                item.value != "EVOLUÇÃO DO PAF" &&
                item.value != "ACOMPANHAMENTO EM GRUPO" &&
                item.value != "EVOLUÇÃO DO ACOMPANHAMENTO EM GRUPO"
              );
            });
          } else {
            this.tipos = response.data.filter((item) => {
              return (
                item.value != "EVOLUÇÃO DO PAF" &&
                item.value != "ACOMPANHAMENTO EM GRUPO" &&
                item.value != "ATIVIDADE SOCIOEDUCATIVA - COLETIVA" &&
                item.value != "EVOLUÇÃO DO ACOMPANHAMENTO EM GRUPO"
              );
            });
          }
        })
        .finally(() => {
          this.loadingTipos = false;
        });
    },
    getServicos() {
      
      axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
        this.servicos = response.data;

        if (this.morph && this.morph.type == "ScfvGrupo") {
          //Força o Select a receber o ID do Serviços do SCFV
          this.item.tipo_servico_id = this.servicos.filter(function (item) {
            return item.value == "SERVIÇO DE CONVIVÊNCIA E FORTALECIMENTO DE VÍNCULOS" 
              ? item.id
              : null;
          });
          this.disabledServico = true;
        }
      });
    },
    addItem() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      if (this.format_hora) {
        this.item.hora = this.format_hora;
        var time = moment(this.item.hora).format("HH:mm");
        this.item.hora = time;
      }

      this.item.data = moment(this.dataAdd, "YYYY-MM-DD").format("DD/MM/YYYY");

      if (this.familia) {
        this.item.familia_id = this.familia.id;
      }
      if (this.morph) {
        this.item.morph = this.morph;

        this.item.morph_id = this.morph.id;
        this.item.morph_type = this.morph.type;
      }

      if (this.morph && this.morph.type == "ScfvGrupo") {
        this.item.tipo_servico_id = this.item.tipo_servico_id[0]["id"];
      }

      axios
        .post(`api/dashboard/atividades`, this.item)
        .then((response) => {
          this.atividade_id = response.data.data.item.id;
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          if (this.morph != undefined) {
            this.edit_modal = true;
          } else {
            this.$router.push("/dashboard/atividades/edit/" + response.data.data.item.id);
          }
        })
        .catch((e) => {
          this.$snack.success({
            button: false,
            text: e,
          });
          ladda.stop();
        });
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay();
      const day = date.getDate();
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6;
    },
  },
};
</script>
